/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Request to update an existing claim status template
 * @export
 * @interface UpdateClaimStatusTemplateRequest
 */
export interface UpdateClaimStatusTemplateRequest {
    /**
     * Name of the status
     * @type {string}
     * @memberof UpdateClaimStatusTemplateRequest
     */
    displayName?: string;
    /**
     * Order in which statuses should be displayed
     * @type {number}
     * @memberof UpdateClaimStatusTemplateRequest
     */
    displayOrder?: number;
    /**
     * Optional color code for UI display
     * @type {string}
     * @memberof UpdateClaimStatusTemplateRequest
     */
    color?: string | null;
    /**
     * Optional description of the status
     * @type {string}
     * @memberof UpdateClaimStatusTemplateRequest
     */
    description?: string | null;
    /**
     * Whether this status is active
     * @type {boolean}
     * @memberof UpdateClaimStatusTemplateRequest
     */
    isActive?: boolean;
}

/**
 * Check if a given object implements the UpdateClaimStatusTemplateRequest interface.
 */
export function instanceOfUpdateClaimStatusTemplateRequest(value: object): value is UpdateClaimStatusTemplateRequest {
    return true;
}

export function UpdateClaimStatusTemplateRequestFromJSON(json: any): UpdateClaimStatusTemplateRequest {
    return UpdateClaimStatusTemplateRequestFromJSONTyped(json, false);
}

export function UpdateClaimStatusTemplateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateClaimStatusTemplateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'displayName': json['displayName'] == null ? undefined : json['displayName'],
        'displayOrder': json['displayOrder'] == null ? undefined : json['displayOrder'],
        'color': json['color'] == null ? undefined : json['color'],
        'description': json['description'] == null ? undefined : json['description'],
        'isActive': json['isActive'] == null ? undefined : json['isActive'],
    };
}

export function UpdateClaimStatusTemplateRequestToJSON(json: any): UpdateClaimStatusTemplateRequest {
    return UpdateClaimStatusTemplateRequestToJSONTyped(json, false);
}

export function UpdateClaimStatusTemplateRequestToJSONTyped(value?: UpdateClaimStatusTemplateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'displayName': value['displayName'],
        'displayOrder': value['displayOrder'],
        'color': value['color'],
        'description': value['description'],
        'isActive': value['isActive'],
    };
}

